var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPenNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1662602208980,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 79982,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M725.333333 320v469.333333a85.333333 85.333333 0 0 0 85.333334-85.333333V362.666667h-42.666667v-42.666667h42.666667a42.666667 42.666667 0 0 1 42.666666 42.666667v341.333333a128.042667 128.042667 0 0 1-106.666666 126.229333V832H341.333333a128 128 0 0 1-128-128V234.666667a42.666667 42.666667 0 0 1 42.666667-42.666667h426.666667a42.666667 42.666667 0 0 1 42.666666 42.666667v85.333333z m-405.333333 85.333333a21.333333 21.333333 0 0 0 0 42.666667h256a21.333333 21.333333 0 0 0 0-42.666667H320z m0 128a21.333333 21.333333 0 0 0 0 42.666667h256a21.333333 21.333333 0 0 0 0-42.666667H320z",
    fill: "#ffffff",
    "p-id": 79983
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenNumber);
export default __webpack_public_path__ + "static/media/penNumber.7ed3f570.svg";
export { ForwardRef as ReactComponent };